import { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import { Input, Radio } from 'antd';

const { TextArea } = Input;

const EmailEditor = ({
  emailContent,
  setHtmlContent,
  setSubjectContent,
  defaultNotificationTemplate,
  subjectEditorContent,
  setSubjectEditorContent,
  bodyEditorContent,
  setBodyEditorContent,
  editingMode,
  setEditingMode,
  subjectContent,
  setEmailDefaultBodyContent,
  setEmailDefaultSubjectContent,
}) => {
  const quillRef = useRef();
  const htmlEditorRef = useRef();

  const [onChangeBodyTriggered, setOnChangeBodyTriggered] = useState(0);
  const [onChangeSubjectTriggered, setOnChangeSubjectTriggered] = useState(0);

  useEffect(() => {
    if (defaultNotificationTemplate) {
      setSubjectEditorContent(
        defaultNotificationTemplate?.email?.subject || ''
      );
      setBodyEditorContent(defaultNotificationTemplate?.email?.body || '');
    }
  }, [
    defaultNotificationTemplate,
    setBodyEditorContent,
    setSubjectEditorContent,
  ]);

  const toolbarOptions = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline'],
    [{ color: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['image'], // Add image option to toolbar
  ];

  const modules = {
    toolbar: toolbarOptions,
    clipboard: {
      matchVisual: false,
    },
  };

  const handleChange = (content, delta, source, editor) => {
    if (editingMode === 'body') {
      if (onChangeBodyTriggered === 0) {
        setEmailDefaultBodyContent && setEmailDefaultBodyContent(content);
      }
      setBodyEditorContent(content);
      setOnChangeBodyTriggered(onChangeBodyTriggered + 1);
      setHtmlContent(editor.getHTML());
    } else if (editingMode === 'subject') {
      if (onChangeSubjectTriggered === 0) {
        setEmailDefaultSubjectContent && setEmailDefaultSubjectContent(content);
      }
      setOnChangeSubjectTriggered(onChangeSubjectTriggered + 1);
      setSubjectEditorContent(content);
      setSubjectContent(editor.getHTML());
    }
  };

  return (
    <>
      <Radio.Group
        defaultValue="subject"
        onChange={(e) => setEditingMode(e.target.value)}
        style={{ marginBottom: '2px', marginTop: '4px' }}
      >
        <Radio.Button value="subject">Subject</Radio.Button>
        <Radio.Button value="body">Body</Radio.Button>
      </Radio.Group>
      {editingMode === 'body' ? (
        <>
          <div className="h-[16rem] border-2 border-[#ccc] rounded-lg mt-2">
            <ReactQuill
              ref={quillRef}
              theme="snow"
              modules={modules}
              className="organization h-full"
              onChange={handleChange}
              value={emailContent ? emailContent : bodyEditorContent}
            />
          </div>
          <div className="h-[16rem] border-2 border-[#ccc] rounded-lg mt-4">
            <div className="grid grid-cols-1 gap-4">
              <TextArea
                bordered={false}
                rows={10}
                style={{
                  resize: 'none',
                  fontFamily: 'Poppins',
                }}
                ref={htmlEditorRef}
                value={emailContent}
                readOnly
              />
            </div>
          </div>
        </>
      ) : null}
      {editingMode === 'subject' ? (
        <div className="h-[33rem] border-2 border-[#ccc] rounded-lg mt-2">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            modules={modules}
            className="organization h-[38rem]"
            onChange={handleChange}
            value={subjectContent ? subjectContent : subjectEditorContent}
          />
        </div>
      ) : null}
    </>
  );
};

export default EmailEditor;
